import React from 'react';
import SupplierLayout from '../../layouts/SupplierLayout';
import AllCategories from '../../components/Tables/AllCategories';

const CategoryPage = () => {
	return (
		<SupplierLayout>
			<AllCategories />
		</SupplierLayout>
	);
};
export default CategoryPage;
